import { render, staticRenderFns } from "./PostingSupplyCaseUpload.vue?vue&type=template&id=a24240e4&"
import script from "./PostingSupplyCaseUpload.vue?vue&type=script&lang=js&"
export * from "./PostingSupplyCaseUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports